import cn from 'classnames';
import * as React from 'react';

import * as styles from './MortgageBankTemplate.css';
import { Ticker } from '../../helpers/Ticker/Ticker';

interface IMortgageAsideTemplate {
  image: string;
  title: string;
  url: string;
  label: string;
  description: string;
  annotation: string;
  bannerId: string;
  onClick(): void;
}

export const MortgageBankTemplate: React.VFC<IMortgageAsideTemplate> = props => {
  return (
    <a
      data-testid="MortgageBankTemplate"
      style={{ backgroundImage: `url(${props.image})` }}
      target="_blank"
      rel="noreferrer noopener"
      href={props.url}
      className={cn(
        props.title && props.description
          ? styles['mortgage-offer-card-aside-template-wrapper']
          : styles['mortgage-offer-card-aside-template-image-only-wrapper'],
      )}
      onClick={props.onClick}
    >
      {props.label && <div className={styles['disclaimer']}>{props.label}</div>}
      <div className={styles['title']}>{props.title}</div>
      <div className={styles['description']}>{props.description}</div>
      {props.annotation && (
        <div className={styles['annotation']}>
          <Ticker text={props.annotation} />
        </div>
      )}
    </a>
  );
};
